module.exports = __webpack_public_path__ + "static/media/down.e6a68d3c.svg";